import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { PasswordErrorStateMatcher } from '@app/shared/error-state-matcher/password-error-state-matcher';
import { BaseWithBundleComponent } from '@app/shared/components/base/base-with-bundle.component';
import { ComponentServiceBundle } from '@app/core/services/base/component-service-bundle.service';
import { SmpUtils } from '@app/core/helpers/utilities';

@Component({
    selector: 'dr-password',
    templateUrl: './dr-password.component.html',
    styleUrls: ['./dr-password.component.scss']
})
export class DrPasswordComponent extends BaseWithBundleComponent
                                 implements OnInit {
    @Output()
    public updatePassword = new EventEmitter<string>();

    public errorStateMatcher: PasswordErrorStateMatcher;
    public recoverPasswordForm: UntypedFormGroup;

    public showPassword: boolean;

    get hasUpper(): boolean {
        return SmpUtils.hasUpperChar(this.password1Value);
    }

    get hasLower(): boolean {
        return SmpUtils.hasLowerChar(this.password1Value);
    }

    get hasNumber(): boolean {
        return SmpUtils.hasNumberChar(this.password1Value);
    }

    get hasSpecial(): boolean {
        return SmpUtils.hasSpecialChar(this.password1Value);
    }

    get has8(): boolean {
        return SmpUtils.hasLength(this.password1Value, 8);
    }

    get password1Value(): string {
        return this.recoverPasswordForm && this.recoverPasswordForm.controls && this.recoverPasswordForm.controls.password1 ?
            this.recoverPasswordForm.controls.password1.value :
            '';
    }

    constructor(protected componentServiceBundle: ComponentServiceBundle,
                protected formBuilder: UntypedFormBuilder) {
        super(componentServiceBundle);
    }

    public ngOnInit() {
        this.showPassword = false;
        this.errorStateMatcher = new PasswordErrorStateMatcher();
        this.recoverPasswordForm = this.formBuilder.group({
            password1: ['', [Validators.required, Validators.pattern(new RegExp(SmpUtils.passwordRegex))]],
            password2: ['']
        }, { validator: this.checkPasswords });
    }

    private checkPasswords(group: UntypedFormGroup) {
        const pass1 = group.controls.password1.value;
        const pass2 = group.controls.password2.value;

        return pass1 === pass2 ? null : { notEqual: true };
    }

    public toggleShowPassword(): void {
        this.showPassword = !this.showPassword;
    }

    public validatePassword(): void {
        const val = this.recoverPasswordForm.valid ? this.password1Value : '';
        this.updatePassword.emit(val);
    }

}
